// Shared trigger-button overrides so every select in the campaign forms matches
// the surface, hover and focus treatment of the `Input` component.
export const CAMPAIGN_SELECT_CLASS =
  '[&>div>button]:bg-n-alpha-black2 [&>div>button:not(.focused)]:dark:outline-n-weak [&>div>button:not(.focused)]:hover:!outline-n-slate-6';
